<template>
  <ActivityHistoryTable
    :title="text.title"
    :subtitle="text.subtitle"
    :loading="loading"
    :rows="rows"
    :loading-text="text.loading"
    :empty-text="text.empty"
  />
</template>

<script>
import salesService from '@/services/sales';
import { SALES_TEXT } from '@/texts/catalog/sales';
import { extractCollection } from '@/utils/dataNormalization';
import { formatDateTime } from '@/utils/datePresentation';
import ActivityHistoryTable from '@/components/common/ActivityHistoryTable.vue';

const HISTORY_TEXT = SALES_TEXT.shared.history;

export default {
  name: 'SaleSharedHistoryTab',
  components: {
    ActivityHistoryTable,
  },
  props: {
    saleId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      text: HISTORY_TEXT,
      loading: false,
      rows: [],
      requestToken: 0,
    };
  },
  watch: {
    saleId: {
      immediate: true,
      handler() {
        this.loadHistory();
      },
    },
  },
  methods: {
    async loadHistory() {
      const saleId = Number(this.saleId || 0);
      if (saleId <= 0) {
        this.rows = [];
        return;
      }

      this.loading = true;
      const token = this.requestToken + 1;
      this.requestToken = token;

      try {
        const response = await salesService.activity(saleId, { per_page: 200 });
        if (token !== this.requestToken) {
          return;
        }

        this.rows = extractCollection(response)
          .map((row) => this.mapHistoryRow(row))
          .filter((row) => row !== null);
      } catch (error) {
        if (token === this.requestToken) {
          this.rows = [];
        }
      } finally {
        if (token === this.requestToken) {
          this.loading = false;
        }
      }
    },
    mapHistoryRow(raw) {
      if (!raw || typeof raw !== 'object') {
        return null;
      }

      const moduleCode = String(raw.module || '').trim().toLowerCase();
      const eventType = String(raw.event_type || '').trim().toLowerCase();

      return {
        id: Number(raw.id || 0) || `${moduleCode}-${eventType}-${Date.now()}`,
        date_label: String(raw.date_label || '').trim() || formatDateTime(raw.happened_at || raw.created_at),
        module_label: String(raw.module_label || '').trim() || this.toTitle(moduleCode) || this.text.fallback.module,
        event_label: String(raw.event_label || '').trim() || this.toTitle(eventType) || this.text.fallback.event,
        description_label: String(raw.description_label || '').trim()
          || String(raw.description || raw.title || this.text.fallback.description).trim(),
        actor_label: String(raw.actor_label || raw.actor_name || this.text.fallback.actor).trim(),
      };
    },
    toTitle(value) {
      const normalized = String(value || '').trim().replace(/[_-]+/g, ' ');
      if (normalized === '') {
        return '';
      }

      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    },
  },
};
</script>